import { apiClient } from '@/api/client'

/** NotebookLM 取り込みジョブの状態 */
export type NotebooklmJob = {
  id: number
  product_id: number
  product_title: string | null
  notebook_url: string | null
  status: 'pending' | 'running' | 'completed' | 'failed'
  progress: number
  total_sources: number
  processed_sources: number
  message: string
  error: string | null
  created_at: string
  started_at: string | null
  completed_at: string | null
}

/** 作品と NotebookLM ノートブックの紐づけ */
export type NotebooklmLink = {
  product_id: number
  notebook_id: string
  notebook_url: string
  source_count: number
  created_at: string
  updated_at: string
}

/** 作品ごとの紐づけと未完了ジョブ */
export type NotebooklmStatus = {
  link: NotebooklmLink | null
  job: NotebooklmJob | null
}

/**
 * 作品を NotebookLM に取り込むジョブを登録する（管理者のみ）
 */
export const requestProductNotebooklm = async (productId: number): Promise<NotebooklmJob> => {
  const res = await apiClient.post(`/p/${productId}/notebooklm`)
  return res.data
}

/**
 * 指定作品の紐づけと未完了ジョブを取得する（管理者のみ）
 */
export const getProductNotebooklm = async (productId: number): Promise<NotebooklmStatus> => {
  const res = await apiClient.get(`/p/${productId}/notebooklm`)
  return res.data
}

/**
 * 作品とノートブックの紐づけを解除する（NotebookLM 側は削除しない）
 */
export const unlinkProductNotebooklm = async (productId: number): Promise<void> => {
  await apiClient.delete(`/p/${productId}/notebooklm`)
}

/**
 * すべての紐づけを取得する（作品一覧のメニュー表示に使う）
 */
export const getNotebooklmLinks = async (): Promise<NotebooklmLink[]> => {
  const res = await apiClient.get('/notebooklm-links')
  return res.data
}

/**
 * 自分の取り込みジョブ履歴を取得する（管理者のみ）
 */
export const getNotebooklmJobs = async (): Promise<NotebooklmJob[]> => {
  const res = await apiClient.get('/notebooklm-jobs')
  return res.data
}
